const { CircularProgress, TextField } = window.Material;
const { Autocomplete } = (window as any).labMaterial;

export interface OptionSelected {
	value?: string;
	label?: string;
	[key: string]: any;
}

export interface SelectProps {
  onChange?: (value: object) => void;
  value?: any;
  creatable: boolean;
  label?: string;
  groupBy?: any;
  placeholder?: string;
  getOptionLabel?: (option: OptionSelected) => string;
  disabled?: boolean;
  options: OptionSelected[];
  defaultValue?: any;
  PopperComponent?: any;
  multi?: boolean | any;
  className: string;
  loading?: boolean;
  onInputChange?: (event: React.ChangeEvent) => void;
  mandatory: boolean;
  error?: string;
  filterOptions?: (options: OptionSelected[], params: any) => OptionSelected[];
  id?: string;
  renderTags?: Function | any;
  getOptionDisabled?: Function;
  renderOption?: Function;
  renderInput?: Function;
  important?: string;
  helperText?: string;
  filterSelectedOptions?: boolean;
  isClearable?: boolean;
  getOptionSelected?: (option:any, value:any) => boolean;
  style?: any;
  excludedOptions?: any;
}

// @ts-ignore
export default class Select extends window.React.PureComponent<SelectProps, {}> {
	static defaultProps: SelectProps = {
		multi: false,
		creatable: false,
		options: [],
		className: '',
		mandatory: false,
	};

  render() {
    const {
      label,
      loading,
      disabled,
      onChange,
      options,
      value,
      multi,
      placeholder,
      onInputChange,
      className,
      mandatory,
      getOptionLabel,
      error,
      filterOptions,
      creatable,
      id,
      renderTags,
      getOptionDisabled,
      renderOption,
      renderInput,
      groupBy,
      important,
      helperText,
      PopperComponent,
      filterSelectedOptions,
      getOptionSelected,
      isClearable,
      style
    } = this.props;
    // @ts-ignore
    const finalValue = multi ? (value ? value : []) : value;
    return (
      <Autocomplete
        id={id}
        disabled={disabled}
        className={className}
        groupBy={groupBy}
        filterOptions={filterOptions}
        filterSelectedOptions={filterSelectedOptions ?? true}
        PopperComponent={PopperComponent}
        loading={loading}
        // debug={true}
        // open={true}
        multiple={multi}
        onChange={(_, value: any): void => onChange && onChange(value)}
        options={options}
        getOptionSelected={
          getOptionSelected ??
            ((option: OptionSelected, value: OptionSelected): boolean => option?.value === value?.value)
        }
        getOptionDisabled={getOptionDisabled}
        getOptionLabel={
          getOptionLabel
            ? getOptionLabel
            : (option: any): string => {
                return option?.label || '';
              }
        }
        disableClearable={!isClearable}
        renderTags={renderTags}
        ChipProps={{
          size: 'small',
        }}
        style={style}
        renderInput={renderInput ? renderInput : (params: any) => (
          <TextField
            {...params}
            label={label}
            onChange={onInputChange ? onInputChange : params.onChange}
            placeholder={
              placeholder ||
              ((multi && finalValue?.length === 0) || (!multi && !finalValue)
                ? `${window.Alfresco.messages.global['button.select']}...`
                : '')
            }
            variant={'outlined'}
            required={mandatory}
            error={!!error}
            helperText={error || important || helperText}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            InputLabelProps={{ shrink: true }}
          />
        )}
        value={finalValue ?? null}
        freeSolo={creatable}
        renderOption={renderOption}
      />
    );
  }
}
